import React, { useState } from "react";
import Track from "./Track";
import './Playlist.css';

function Playlist(props) {
    const [playlistName, setPlaylistName] = useState('');

    const handleChange = (event) => {
        event.preventDefault();
        setPlaylistName(event.target.value);
    }

    //function to remove a track
    const handleClick = (event) => {
        event.preventDefault();
        const trackId = event.target.id;
        console.log(trackId);
        const newArr = props.playlist.filter((track) => {
            //console.log("track id: " + track.id);
            return track.id !== trackId
        });
        console.log(newArr);
        props.setPlaylist(newArr);
    }


    const handleSubmit = (event) => {
        event.preventDefault();
        
        const name = playlistName;
        //map the track uris to a new array that can be sent via the fetch request
        const trackUris = props.playlist.map((track) => track.uri);
        //console.log(trackUris);
        props.savePlaylist(name, trackUris);
        setPlaylistName('');
        props.setPlaylist([]);
    }

    return (
        <div className="playlist">
            <h2>Playlist Creation</h2>
            <form onSubmit={handleSubmit}>
                <input 
                    type="text" 
                    onChange={handleChange} 
                    value={playlistName}
                    placeholder="Enter a playlist name..." 
                    required
                />
                <div>
                    {props.playlist.map((track) => {
                        return (
                            <div>
                                <Track 
                                    name={track.name}
                                    artist={track.artist}
                                    album={track.album}
                                />
                                <button id={track.id} onClick={handleClick}>-</button>
                            </div>
                        );
                    })}
                </div>
                <button type="submit">Save Playlist</button>
            </form>
        </div>
    );
}

export default Playlist;